// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RadioGroup[data-v-668448ef]{display:inline-block;font-family:Open Sans,sans-serif;margin-bottom:20px}.RadioGroup .label[data-v-668448ef]{position:relative}.RadioGroup .items[data-v-668448ef]{display:flex;flex-direction:column}.RadioGroup .text-items .radio[data-v-668448ef]{padding-bottom:10px}.RadioGroup .text-items .radio[data-v-668448ef]:last-child{padding-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
